import f3tch from 'f3tch';

import API_URL from '../../constants/url.constant.api';
import profile from '../../profiles/json.profile.api';

const createNotificationApi = (notification) =>
  f3tch('/notifications')
    .profile(profile({url: API_URL()}))
    .body(notification)
    .post();

export default createNotificationApi;
